// ===== File: src/pages/Listing/PopularCategoriesInLocationSkeleton.tsx =====
import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';

interface PopularCategoriesInLocationSkeletonProps {
  title?: string;
}

const PopularCategoriesInLocationSkeleton: React.FC<PopularCategoriesInLocationSkeletonProps> = ({ 
  title = 'Popular Services' 
}) => {
  // Generate 10 skeleton entries as specified
  const skeletonItems = Array.from({ length: 10 }, (_, index) => (
    <div 
      key={index}
      className="list-group-item list-group-item-action d-flex justify-content-between align-items-center border-0 py-3"
    >
      <div className="d-flex align-items-center flex-grow-1">
        {/* Category name skeleton */}
        <div 
          className="skeleton-line"
          style={{
            width: `${Math.random() * 60 + 80}px`, // Random width between 80-140px
            height: '16px',
            backgroundColor: '#e9ecef',
            borderRadius: '4px',
            animation: 'skeleton-pulse 1.5s ease-in-out infinite'
          }}
        />
      </div>
      {/* Count badge skeleton */}
      <div 
        className="skeleton-line"
        style={{
          width: '24px',
          height: '20px',
          backgroundColor: '#e9ecef',
          borderRadius: '12px',
          animation: 'skeleton-pulse 1.5s ease-in-out infinite'
        }}
      />
    </div>
  ));

  return (
    <>
      <style>
        {`
          @keyframes skeleton-pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.6;
            }
          }
        `}
      </style>
      <Card className="mb-4">
        <CardHeader>
          <h5 className="card-title mb-0">{title}</h5>
        </CardHeader>
        <CardBody>
          <div className="list-group list-group-flush">
            {skeletonItems}
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default PopularCategoriesInLocationSkeleton;